"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLocalization = exports.LocalizationContext = exports.mergeLocalizationDataAltStore = exports.getLocalizationData = void 0;
const react_1 = __importDefault(require("react"));
const messageCode_1 = require("../utils/messageCode");
const LocaleHandler_1 = require("../locale/LocaleHandler");
/**
 * Return a standard object intended to be stored inside of the LocalizationContext
 */
function getLocalizationData(config, locale) {
    const messages = LocaleHandler_1.getMessagesForLocale(config, locale) || {
        messageProperties: undefined,
        supportedLocales: undefined
    };
    return {
        locale,
        messages: messages.messageProperties,
        supportedLocales: messages.supportedLocales,
        allLocales: config.allLocales,
        defaultLocale: config.DEFAULT_LOCALE // 'en-US'
    };
}
exports.getLocalizationData = getLocalizationData;
/**
 * Map properties from an Alt LocalizationStore instance to an object which will be sent to the LocalizationContext
 */
function mergeLocalizationDataAltStore(LocalizationStore, defaultLocale) {
    const allLocales = [];
    if (LocalizationStore.supportedLocales && LocalizationStore.supportedLocales.length) {
        LocalizationStore.supportedLocales.forEach((locale) => {
            allLocales.push(locale.lang);
        });
    }
    return {
        messages: LocalizationStore.messages,
        supportedLocales: LocalizationStore.supportedLocales,
        locale: LocalizationStore.locale,
        allLocales,
        defaultLocale: defaultLocale || ''
    };
}
exports.mergeLocalizationDataAltStore = mergeLocalizationDataAltStore;
// <LocalizationContext.Consumer> or <LocalizationContext.Provider>
exports.LocalizationContext = react_1.default.createContext({
    messages: {},
    locale: '',
    supportedLocales: [],
    allLocales: [],
    defaultLocale: ''
});
/**
 * Higher order component.  Easily hand over the localization details to a Component.
 * this.props.i18n and this.props.getMessage() will be available on the component
 * Example: export default withLocalization(App);
 */
function withLocalization(Component) {
    class LocalizedComponent extends react_1.default.PureComponent {
        constructor() {
            super(...arguments);
            this.getMessage = (code, args) => messageCode_1.getMessage(this.context.messages, code, args);
        }
        render() {
            return react_1.default.createElement(Component, Object.assign({}, this.props, this.context, { i18n: this.context, getMessage: this.getMessage }));
        }
    }
    LocalizedComponent.contextType = exports.LocalizationContext;
    return LocalizedComponent;
}
exports.withLocalization = withLocalization;
//# sourceMappingURL=LocalizationContext.js.map